export class Kevel {
  endpoint = 'https://e-11757.adzerk.net/api/v2';
  divName = null;
  lastParams = null;
  parentBlock = null;

  async getClientIP() {
    // https://ipinfo.io/json
    // https://api.ipify.org?format=json
    return await fetch('https://ipinfo.io/json')
      .then(response => response.json())
      .then(data => data.ip);
  }

  setDivName(divName) {
    this.divName = divName;
    return this;
  }

  setParent(block) {
    this.parentBlock = block;
    return this;
  }

  get1PartyCookie() {
    let cookieData = document.cookie;
    let match = cookieData.match(/adstax_uid=([^;]+)/);
    let value = match ? match[1] : null;
    if (value !== null) return value;
  }

  getUserConsent() {
    return localStorage.getItem('accept_gdpr') ? true : false;
  }

  load(placements, keywords = null) {
    this.lastParams = [placements, keywords]

    this.getClientIP().then(ip => {
      fetch(this.endpoint, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'User-Agent': window.navigator.userAgent,
      },
      body: JSON.stringify({
        placements: placements,
        keywords: keywords,
        enableBotFiltering: true,
        user: {
          key: this.get1PartyCookie()
        },
        ip: ip,
        consent: {
          gdpr: this.getUserConsent()
        },
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        document.dispatchEvent(
          new CustomEvent(`onKevelSuccess-${this.divName}`, {
            detail: data 
          })
        );
      })
      .catch((error) => {
        document.dispatchEvent(
          new CustomEvent(`onKevelError-${this.divName}`, {
            detail: error,
          })
        );
      })
      .finally(() => {
        document.dispatchEvent(new CustomEvent(`onKevelComplete-${this.divName}`));
      });
    }) 

    return this;
  }

  onSuccess(callback) {
    document.addEventListener(`onKevelSuccess-${this.divName}`, callback);
    return this;
  }

  onError(callback) {
    document.addEventListener(`onKevelError-${this.divName}`, callback);
    return this;
  }

  onComplete(callback) {
    document.addEventListener(`onKevelComplete-${this.divName}`, callback);
    return this;
  }

  onReload() {
    const parentBlock = document.getElementById(this.parentBlock);

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        this.load(...this.lastParams);
      })
    });

    const config = {
      attributes: true,
      childList: true,
      characterData: true
    };

    observer.observe(parentBlock, config);
    return this;
  }

  sendImpression(element, campaign) {
    const viewedBanners = new Set();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entrie, index) => {
        if (entrie.isIntersecting && !viewedBanners.has(campaign.flightId)) {
          viewedBanners.add(campaign.flightId);
          fetch(campaign.impressionUrl);
          getBannerPushGTM('viewBanner', index, entrie.target.firstElementChild);
        }
      })
    }, { threshold: 0.5 });

    observer.observe(element);
    return this;
  }
}